module.exports = __webpack_public_path__ + "img/24.1a607923.jpg";